export type RegionId = 'AND' | 'OR' | 'NAND' | 'NOT';

export interface BoardComponent {
  ref: string;
  value: string;
  x: number;
  y: number;
  rotation: number;
  layer: string;
  type: string;
  region: RegionId;
}

export interface RegionDefinition {
  id: RegionId;
  title: string;
  chip: string;
  formula: string;
  switches: string[];
  led: string;
  center: [number, number, number];
  accent: number;
}

export interface RegionState {
  a: boolean;
  b: boolean;
  output: boolean;
}

export type StateMap = Record<RegionId, RegionState>;

export const REGIONS: RegionDefinition[] = [
  { id: 'AND', title: '与门', chip: '74HC08N', formula: 'Y = A · B', switches: ['SW1', 'SW2'], led: 'D1', center: [-0.052, 0.005, -0.025], accent: 0x4de3ff },
  { id: 'OR', title: '或门', chip: '74HC32N', formula: 'Y = A + B', switches: ['SW3', 'SW4'], led: 'D2', center: [0.052, 0.005, -0.025], accent: 0x8aff80 },
  { id: 'NAND', title: '与非门', chip: '74HC00N', formula: 'Y = ¬(A · B)', switches: ['SW5', 'SW6'], led: 'D3', center: [-0.052, 0.005, 0.025], accent: 0xffc857 },
  { id: 'NOT', title: '非门', chip: '74HC00N', formula: 'Y = ¬A', switches: ['SW7'], led: 'D4', center: [0.052, 0.005, 0.025], accent: 0xff6b9e },
];
